import { Pipe, PipeTransform } from '@angular/core';
import {
  addDays,
  addHours,
  addMinutes,
  addMonths,
  addYears,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInSeconds,
  differenceInYears,
  isValid,
  parseISO,
} from 'date-fns';

@Pipe({
  name: 'formatDateDistanceCompact',
})
export class FormatDateDistanceCompactPipe implements PipeTransform {
  private readonly maxUnits = 2;
  private readonly unitMap = [
    {
      label: $localize`:@@date.distance.compact.pipe.year:yr`,
      fn: differenceInYears,
      addFn: addYears,
    },
    {
      label: $localize`:@@date.distance.compact.pipe.month:mth`,
      fn: differenceInMonths,
      addFn: addMonths,
    },
    {
      label: $localize`:@@date.distance.compact.pipe.day:d`,
      fn: differenceInDays,
      addFn: addDays,
    },
    {
      label: $localize`:@@date.distance.compact.pipe.hour:h`,
      fn: differenceInHours,
      addFn: addHours,
    },
    {
      label: $localize`:@@date.distance.compact.pipe.minute:m`,
      fn: differenceInMinutes,
      addFn: addMinutes,
    },
    {
      label: $localize`:@@date.distance.compact.pipe.second:s`,
      fn: differenceInSeconds,
    },
  ];

  transform(input: string | number | Date): string {
    const parts: string[] = [];
    const date = this.normalizeDate(input);
    if (!date) return '';

    const now = new Date();
    let start = date < now ? date : now;
    const end = date < now ? now : date;

    this.unitMap.forEach((u) => {
      if (parts.length >= this.maxUnits) return;

      const diff = u.fn(end, start);
      if (diff > 0) {
        parts.push(`${diff}${u.label}`);
        if (u.addFn) start = u.addFn(start, diff);
      }
    });

    return parts.length
      ? parts.join(' ')
      : `0${$localize`:@@date.distance.compact.pipe.second:s`}`;
  }

  private normalizeDate(input: string | number | Date): Date | null {
    if (input instanceof Date && isValid(input)) return input;
    if (typeof input === 'number') return new Date(input);
    if (typeof input === 'string') {
      const parsed = parseISO(input);
      return isValid(parsed) ? parsed : null;
    }
    return null;
  }
}
